// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/dashboard.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { StatsRow } from "./reporting_pb.js";
import { DateRange, Pagination, PaginationMeta } from "./common_pb.js";

/**
 * @generated from message tracker.v1.DashboardOverview
 */
export class DashboardOverview extends Message<DashboardOverview> {
  /**
   * @generated from field: tracker.v1.StatsRow current = 1;
   */
  current?: StatsRow;

  /**
   * @generated from field: tracker.v1.StatsRow previous = 2;
   */
  previous?: StatsRow;

  /**
   * Percentage change per metric key vs previous period (e.g. "12.5" for +12.5%).
   *
   * @generated from field: map<string, string> deltas = 3;
   */
  deltas: { [key: string]: string } = {};

  constructor(data?: PartialMessage<DashboardOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DashboardOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "current", kind: "message", T: StatsRow },
    { no: 2, name: "previous", kind: "message", T: StatsRow },
    { no: 3, name: "deltas", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DashboardOverview {
    return new DashboardOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DashboardOverview {
    return new DashboardOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DashboardOverview {
    return new DashboardOverview().fromJsonString(jsonString, options);
  }

  static equals(a: DashboardOverview | PlainMessage<DashboardOverview> | undefined, b: DashboardOverview | PlainMessage<DashboardOverview> | undefined): boolean {
    return proto3.util.equals(DashboardOverview, a, b);
  }
}

/**
 * @generated from message tracker.v1.PnLPoint
 */
export class PnLPoint extends Message<PnLPoint> {
  /**
   * "YYYY-MM-DD", or "YYYY-MM-DD HH:00" for an hourly trend.
   *
   * @generated from field: string date = 1;
   */
  date = "";

  /**
   * stats carries the full metric bag for the bucket (revenue/cost/profit/roi/…).
   *
   * @generated from field: tracker.v1.StatsRow stats = 2;
   */
  stats?: StatsRow;

  constructor(data?: PartialMessage<PnLPoint>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PnLPoint";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stats", kind: "message", T: StatsRow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PnLPoint {
    return new PnLPoint().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PnLPoint {
    return new PnLPoint().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PnLPoint {
    return new PnLPoint().fromJsonString(jsonString, options);
  }

  static equals(a: PnLPoint | PlainMessage<PnLPoint> | undefined, b: PnLPoint | PlainMessage<PnLPoint> | undefined): boolean {
    return proto3.util.equals(PnLPoint, a, b);
  }
}

/**
 * @generated from message tracker.v1.PerformanceSnapshot
 */
export class PerformanceSnapshot extends Message<PerformanceSnapshot> {
  /**
   * @generated from field: google.protobuf.Timestamp captured_at = 1;
   */
  capturedAt?: Timestamp;

  /**
   * @generated from field: tracker.v1.StatsRow stats = 2;
   */
  stats?: StatsRow;

  /**
   * @generated from field: optional string note = 3;
   */
  note?: string;

  constructor(data?: PartialMessage<PerformanceSnapshot>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PerformanceSnapshot";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "captured_at", kind: "message", T: Timestamp },
    { no: 2, name: "stats", kind: "message", T: StatsRow },
    { no: 3, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PerformanceSnapshot {
    return new PerformanceSnapshot().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PerformanceSnapshot {
    return new PerformanceSnapshot().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PerformanceSnapshot {
    return new PerformanceSnapshot().fromJsonString(jsonString, options);
  }

  static equals(a: PerformanceSnapshot | PlainMessage<PerformanceSnapshot> | undefined, b: PerformanceSnapshot | PlainMessage<PerformanceSnapshot> | undefined): boolean {
    return proto3.util.equals(PerformanceSnapshot, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetOverviewRequest
 */
export class GetOverviewRequest extends Message<GetOverviewRequest> {
  /**
   * Primary window; if previous_period is omitted, server derives prior window of equal length.
   *
   * @generated from field: tracker.v1.DateRange current_period = 1;
   */
  currentPeriod?: DateRange;

  /**
   * @generated from field: optional tracker.v1.DateRange previous_period = 2;
   */
  previousPeriod?: DateRange;

  /**
   * @generated from field: optional string tenant_id = 4;
   */
  tenantId?: string;

  /**
   * metric_keys restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 5;
   */
  metricKeys: string[] = [];

  constructor(data?: PartialMessage<GetOverviewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetOverviewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "current_period", kind: "message", T: DateRange },
    { no: 2, name: "previous_period", kind: "message", T: DateRange, opt: true },
    { no: 4, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOverviewRequest {
    return new GetOverviewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOverviewRequest {
    return new GetOverviewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOverviewRequest {
    return new GetOverviewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOverviewRequest | PlainMessage<GetOverviewRequest> | undefined, b: GetOverviewRequest | PlainMessage<GetOverviewRequest> | undefined): boolean {
    return proto3.util.equals(GetOverviewRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetOverviewResponse
 */
export class GetOverviewResponse extends Message<GetOverviewResponse> {
  /**
   * @generated from field: tracker.v1.DashboardOverview overview = 1;
   */
  overview?: DashboardOverview;

  constructor(data?: PartialMessage<GetOverviewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetOverviewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "overview", kind: "message", T: DashboardOverview },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOverviewResponse {
    return new GetOverviewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOverviewResponse {
    return new GetOverviewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOverviewResponse {
    return new GetOverviewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOverviewResponse | PlainMessage<GetOverviewResponse> | undefined, b: GetOverviewResponse | PlainMessage<GetOverviewResponse> | undefined): boolean {
    return proto3.util.equals(GetOverviewResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetPnLTrendRequest
 */
export class GetPnLTrendRequest extends Message<GetPnLTrendRequest> {
  /**
   * @generated from field: tracker.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * @generated from field: optional string tenant_id = 3;
   */
  tenantId?: string;

  /**
   * metric_keys restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 4;
   */
  metricKeys: string[] = [];

  /**
   * One point per hour instead of per day (PnLPoint.date is then
   * "YYYY-MM-DD HH:00" in the range's zone) — «Сегодня» draws the day's
   * running profit against yesterday's.
   *
   * @generated from field: bool hourly = 5;
   */
  hourly = false;

  /**
   * Only these campaigns («Сегодня» under «Мои»: the caller's own); empty =
   * the whole workspace.
   *
   * @generated from field: repeated string campaign_ids = 6;
   */
  campaignIds: string[] = [];

  constructor(data?: PartialMessage<GetPnLTrendRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetPnLTrendRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "hourly", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "campaign_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPnLTrendRequest {
    return new GetPnLTrendRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPnLTrendRequest {
    return new GetPnLTrendRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPnLTrendRequest {
    return new GetPnLTrendRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPnLTrendRequest | PlainMessage<GetPnLTrendRequest> | undefined, b: GetPnLTrendRequest | PlainMessage<GetPnLTrendRequest> | undefined): boolean {
    return proto3.util.equals(GetPnLTrendRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetPnLTrendResponse
 */
export class GetPnLTrendResponse extends Message<GetPnLTrendResponse> {
  /**
   * @generated from field: repeated tracker.v1.PnLPoint points = 1;
   */
  points: PnLPoint[] = [];

  constructor(data?: PartialMessage<GetPnLTrendResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetPnLTrendResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "points", kind: "message", T: PnLPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPnLTrendResponse {
    return new GetPnLTrendResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPnLTrendResponse {
    return new GetPnLTrendResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPnLTrendResponse {
    return new GetPnLTrendResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPnLTrendResponse | PlainMessage<GetPnLTrendResponse> | undefined, b: GetPnLTrendResponse | PlainMessage<GetPnLTrendResponse> | undefined): boolean {
    return proto3.util.equals(GetPnLTrendResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetPerformanceHistoryRequest
 */
export class GetPerformanceHistoryRequest extends Message<GetPerformanceHistoryRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: optional tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * metric_keys restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 4;
   */
  metricKeys: string[] = [];

  constructor(data?: PartialMessage<GetPerformanceHistoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetPerformanceHistoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "date_range", kind: "message", T: DateRange, opt: true },
    { no: 4, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPerformanceHistoryRequest {
    return new GetPerformanceHistoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPerformanceHistoryRequest {
    return new GetPerformanceHistoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPerformanceHistoryRequest {
    return new GetPerformanceHistoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPerformanceHistoryRequest | PlainMessage<GetPerformanceHistoryRequest> | undefined, b: GetPerformanceHistoryRequest | PlainMessage<GetPerformanceHistoryRequest> | undefined): boolean {
    return proto3.util.equals(GetPerformanceHistoryRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetPerformanceHistoryResponse
 */
export class GetPerformanceHistoryResponse extends Message<GetPerformanceHistoryResponse> {
  /**
   * @generated from field: repeated tracker.v1.PerformanceSnapshot snapshots = 1;
   */
  snapshots: PerformanceSnapshot[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<GetPerformanceHistoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetPerformanceHistoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snapshots", kind: "message", T: PerformanceSnapshot, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPerformanceHistoryResponse {
    return new GetPerformanceHistoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPerformanceHistoryResponse {
    return new GetPerformanceHistoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPerformanceHistoryResponse {
    return new GetPerformanceHistoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPerformanceHistoryResponse | PlainMessage<GetPerformanceHistoryResponse> | undefined, b: GetPerformanceHistoryResponse | PlainMessage<GetPerformanceHistoryResponse> | undefined): boolean {
    return proto3.util.equals(GetPerformanceHistoryResponse, a, b);
  }
}

